import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { I18nService } from '@core/i18n-legacy';
import { NotificationsController } from '@core/user-interface-legacy';

@Injectable()
export abstract class ChurnFlowNavigationBaseService {
  protected abstract readonly router: Router;
  protected abstract readonly notificationsController: NotificationsController;
  protected abstract readonly i18n: I18nService;

  public abstract navigateToPlanPicker(): void;
  public abstract navigateToBilling(): Promise<boolean>;
  public abstract stayWithTellent(): void;
}
